import ReplyAttachmentList from './ReplyAttachmentList';

export default ReplyAttachmentList;